function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 15 15"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.333 13.333H1.667V1.667H7.5V0H1.667C.742 0 0 .75 0 1.667v11.666C0 14.25.742 15 1.667 15h11.666C14.25 15 15 14.25 15 13.333V7.5h-1.667zM9.167 0v1.667h2.991L3.967 9.858l1.175 1.175 8.191-8.191v2.991H15V0z",
  style: {
    strokeWidth: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "#015d59"
  },
  vectorEffect: "non-scaling-stroke"
}));
export default SvgExternalLink;